<script>
import CustomOverlay from '@/components/overlay/CustomOverlay.vue'

export default {
  name: 'OverlayError',
  components: { CustomOverlay }
}
</script>

<template>
  <custom-overlay>
    <div class="pt-10">
      <el-empty :image-size="600" description="无效链接"></el-empty>
    </div>
  </custom-overlay>
</template>

<style scoped lang="scss">

</style>
